/**
 * Frontend Configuration for Zap Expenses
 * 
 * Mirroring the 'config.py' structure from the backend to centralize
 * all environment variables and hardcoded constants.
 */

const config = {
    // API & Environment
    API_BASE: process.env.REACT_APP_API_BASE || "https://api.zapexpenses.com",
    NETLIFY_FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || "https://zapexpenses.com",
    // Production builds are off unless REACT_APP_ENABLE_MOCKS=true at build time.
    // `=== 'true' || true` was a tautology: mocks were always on, including production.
    ENABLE_MOCKS: process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_ENABLE_MOCKS === 'true'
        : process.env.REACT_APP_ENABLE_MOCKS !== 'false',

    // Analytics
    GA_MEASUREMENT_ID: process.env.REACT_APP_GA_MEASUREMENT_ID || "G-TBZLVHVNE8",

    // Support & Info
    SUPPORT_EMAIL: "hello@zapexpenses.com",

    // Auth & Routing
    PUBLIC_ROUTES: [
        '/',
        '/help',
        '/support',
        '/pricing',
        '/success',
        '/verify-expired',
        '/privacy.html',
        '/terms.html',
        '/mock',
        '/mockreview',
        '/mockreceipts',
        '/mockmileage',
        '/mtd-2026-guide',
        '/help/mtd-overview',
        '/tools/property-allowance',
        '/tools/mileage-calculator',
        '/speed-test',
        '/partners/onboarding-guide',
        '/partners/margin-calculator',
        '/tools/joint-property-checker',
        '/tools/compliance-checker',
        '/mtd-anxieties/foreign-property-income',
        '/mtd-anxieties/mtd-for-landlords-joint-ownership',
        '/mtd-anxieties/mtd-digital-links-explained',
        '/mtd-anxieties/mtd-exemption-criteria',
        '/why-choose-zap'
    ]
};

export default config;
